// Wrapper to make testing easier
import { v4 } from 'uuid';

export const uuid = () => v4(); // eslint-disable-line import/prefer-default-export
